import { render, staticRenderFns } from "./FormProSetting.vue?vue&type=template&id=0cd4cbfd&scoped=true"
import script from "./FormProSetting.vue?vue&type=script&lang=js"
export * from "./FormProSetting.vue?vue&type=script&lang=js"
import style0 from "./FormProSetting.vue?vue&type=style&index=0&id=0cd4cbfd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd4cbfd",
  null
  
)

export default component.exports